module.exports = __webpack_public_path__ + "static/img/illust_7_mk.6d202704.svg";